"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var effector_1 = require("effector");
var QBAdapter_1 = require("../QBAdapter");
var voidStream_1 = require("../utils/voidStream");
exports.default = (function (get, Dialogs$) {
    var remove = effector_1.createEffect().use(QBAdapter_1.deleteDialog);
    Dialogs$.on(remove.done, function (_state, _a) {
        var params = _a.params;
        var id = params[0];
        if (!id)
            return _state;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var _b = _state, _c = id, _ = _b[_c], restDialogs = __rest(_b, [typeof _c === "symbol" ? _c : _c + ""]);
        return __assign({}, restDialogs);
    });
    effector_1.forward({
        from: remove.done.map(voidStream_1.voidStream),
        to: get,
    });
    return remove;
});
//# sourceMappingURL=remove.js.map